<template>
	<div class="details">
		<p class="title flex">
			<span class="text-ellipsis">{{homeworkInfo.title}}</span>
			<span :style="{color:statusColor}">{{completionStatusText}}</span>
		</p>
		<p class="flex between">
			<span>
				<span class="teacher">{{homeworkInfo.createByName}}</span>
				{{homeworkInfo.releaseTime}}
			</span>
			<span>{{homeworkInfo.number}}人已读</span>
		</p>

		<div style="word-break: break-all" v-html="homeworkInfo.content"></div>

		<!-- 或测试链接 -->
		<!-- <div class="footer">
			<button class="btn-full" @click="toOnlineTest">去测试</button>
		</div>-->

		<!-- 或视频链接 -->
		<div v-if="homeworkInfo.videoCollections?.length">
			<div @click="toVideosDetails(item)" v-for="(item,index) in homeworkInfo.videoCollections" :key="index" class="videos-card suite flex between">
				<div class="img">
					<img :src="item.cover" alt />
				</div>
				<div class="content flex">
					<p class="title">{{item.name}}</p>
					<span v-if="item.type==0" class="video flex">{{item.videoCount}}集</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			ststusList: ["待完成", "已完成"],
			colorList: ["rgba(242, 65, 19, 1)", "rgba(46, 204, 73, 1)"],
			homeworkInfo: {},
		};
	},
	computed:{
		completionStatusText(){
			return this.homeworkInfo.status==2?'已结束':['待完成','已完成'][this.homeworkInfo.completionStatus]
		},
		statusColor(){
			return this.homeworkInfo.status==2?'rgba(242, 65, 19, 1)':this.colorList[this.homeworkInfo.completionStatus]
		}
	},
	mounted() {
		this.getDetails();
	},
	methods: {
		toOnlineTest() {
			this.$router.push("/student/course/onlineTest");
		},
		toVideosDetails(item) {
			let ishomework = this.homeworkInfo.status !=2 && item.completionStatus == 0;
			console.log('toVideosDetails: ', item);
			// type 0-普通 1-AI
			if(item.type==1) this.$router.push(`/student/sports/kinect/details?kinectId=${item.id}&homeworkid=${ishomework?this.$route.query.homeworkId:''}`);
			else this.$router.push({ path: "/student/videos/details", query: { videosId: item.id, ishomework, homeworkid: this.$route.query.homeworkId } });
		},
		async getDetails() {
			try {
				let {success,message,result} = await this.$http.get(`h5/examineWork/getExamineWork?workId=${this.$route.query.homeworkId}`);
				if (!success) throw new Error(message);
				this.homeworkInfo = result;
			} catch (error) {
				console.error("getDetails", error?.message);
			}
		},
	},
};
</script>

<style scoped lang="less">
.details {
	padding: 0 17 / @rem 20 / @rem;
	p {
		font-size: 10 / @rem;
		color: rgba(31, 30, 29, 0.3);
		span.teacher {
			color: rgba(255, 162, 22, 1);
			padding-right: 10 / @rem;
		}
		&.title {
			width: 100%;
			letter-spacing: 1 / @rem;
			font-size: 19 / @rem;
			color: rgba(47, 47, 47, 1);
			font-family: SourceHanSansCN-Medium;
			font-weight: bold;
			span:first-child {
				flex: 1;
			}
			span:last-child {
				font-size: 10 / @rem;
				color: rgba(242, 65, 19, 1);
			}
		}
		&:nth-child(2) {
			padding: 9 / @rem 0 21 / @rem;
		}
	}

	.btn {
		height: 64 / @rem;
		padding: 0 15 / @rem 0;
		margin-top: 21 / @rem;
		button {
			width: 100%;
			height: 100%;
			border-radius: 32 / @rem;
			padding: 0 10 / @rem 0 24 / @rem;
			font-size: 17 / @rem;
			color: white;
			background: linear-gradient(270deg, #ffc756 0%, #ffa216 100%);
			span:first-child {
				flex: 1;
				text-align: left;
				padding-right: 10 / @rem;
			}
			span:last-child {
				width: 44 / @rem;
				height: 44 / @rem;
				border-radius: 50%;
				background-color: rgba(255, 239, 204, 1);
				&::after {
					content: "";
					display: block;
					width: 17 / @rem;
					height: 17 / @rem;
					background-image: url(~@img/icon/ui_arrow_org2.png);
					background-repeat: no-repeat;
					background-size: contain;
				}
			}
		}
	}
}

.videos-card {
	margin: 25 / @rem 0 11 / @rem;
	letter-spacing: 1 / @rem;
	height: 70 / @rem;
	.content {
		flex: 1;
		height: 100%;
		flex-direction: column;
		justify-content: flex-end;
		align-items: flex-start;
		p {
			&.title {
				font-size: 17 / @rem;
				color: rgba(49, 49, 49, 1);
				font-weight: bold;
				display: -webkit-box;
				word-break: break-all;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 1;
				overflow: hidden;
			}
		}
		span.video {
			padding-top: 17 / @rem;
			font-size: 12 / @rem;
			color: rgba(31, 30, 29, 0.3);
			&::before {
				content: "";
				display: inline-block;
				width: 16 / @rem;
				height: 12 / @rem;
				margin-right: 5 / @rem;
				background-image: url(~@img/icon/ui_video.png);
				background-repeat: no-repeat;
				background-size: cover;
			}
		}
	}

	.img {
		position: relative;
		height: 70 / @rem;
		&::before {
			content: "";
			position: absolute;
			display: block;
			top: -6 / @rem;
			width: 80%;
			height: 20 / @rem;
			margin-left: 5%;
			border-radius: 2 / @rem;
			background-color: rgb(255, 239, 199);
			z-index: -2;
		}
		&::after {
			content: "";
			position: absolute;
			display: block;
			top: -3 / @rem;
			width: 86%;
			height: 20 / @rem;
			margin-left: 2%;
			border-radius: 2 / @rem;
			background-color: rgb(255, 197, 107);
			z-index: -2;
		}
		img {
			min-width: 126 / @rem;
			width: 126 / @rem;
			height: 70 / @rem;
			margin-right: 13 / @rem;
			border-radius: 2 / @rem;
			display: inline-block;
			background-color: #bbbbbb;
		}
	}
}
</style>
